import axios from "axios";
import auth from "../auth";
// importing the intercerptor
import interceptor from "../interceptors.js";

interceptor();

const token = auth.getToken();

const COMPLIANCE_ENDPOINT = process.env.VUE_APP_COMPLIANCE_ENDPOINT;

function generateReport(url, period, file) {
  const formData = new FormData();
  formData.append("period", period);
  formData.append("file", file);
  return new Promise((resolve, reject) => {
    fetch(url, {
      method: "POST",
      body: formData,
      headers: {
        Authorization: token
      }
    })
      .then(response => {
        if (response.ok) {
          response.json().then(resolve);
        } else {
          response.json().then(reject);
        }
      })
      .catch(e => {
        reject(e);
      });
  });
}

// Clients
function getCorporateData() {
  return axios.get(COMPLIANCE_ENDPOINT + "/corporate_data");
}

// Clients
function getClients() {
  return axios.get(COMPLIANCE_ENDPOINT + "/clients");
}

// Services
function getServices() {
  return axios.get(COMPLIANCE_ENDPOINT + "/services");
}

// Services
function getSegments() {
  return axios.get(COMPLIANCE_ENDPOINT + "/segments");
}

// Registries
function fetchRecoRegistries() {
  return axios.get(COMPLIANCE_ENDPOINT + "/recos/registries");
}
function generateRecoRegistry(period, file) {
  const url = COMPLIANCE_ENDPOINT + "/recos/registries";
  return generateReport(url, period, file);
}
function fetchTradeRegistries() {
  return axios.get(COMPLIANCE_ENDPOINT + "/trades/registries");
}
function generateTradeRegistry(period, file) {
  const url = COMPLIANCE_ENDPOINT + "/trades/registries";
  return generateReport(url, period, file);
}
function fetchOrdersRegistries() {
  return axios.get(COMPLIANCE_ENDPOINT + "/orders/registries");
}
function generateOrdersRegistry(period, file) {
  const url = COMPLIANCE_ENDPOINT + "/orders/registries";
  return generateReport(url, period, file);
}
function fetchPositionRegistries() {
  return axios.get(COMPLIANCE_ENDPOINT + "/positions/registries");
}
function generatePositionRegistry(period, file) {
  const url = COMPLIANCE_ENDPOINT + "/positions/registries";
  return generateReport(url, period, file);
}

// Solvency
function fetchSolvencyReports() {
  return axios.get(COMPLIANCE_ENDPOINT + "/reports/solvency");
}
function generateSolvency(period, file) {
  const url = COMPLIANCE_ENDPOINT + "/reports/solvency";
  return generateReport(url, period, file);
}
// SolvencyConsolidated
function fetchSolvencyConsolidatedReports() {
  return axios.get(COMPLIANCE_ENDPOINT + "/reports/solvencyconsolidated");
}
function generateSolvencyConsolidated(period, file) {
  const url = COMPLIANCE_ENDPOINT + "/reports/solvencyconsolidated";
  return generateReport(url, period, file);
}
// EEFF
function fetchEEFFReports() {
  return axios.get(COMPLIANCE_ENDPOINT + "/reports/eeff");
}
function generateEEFF(period, file) {
  const url = COMPLIANCE_ENDPOINT + "/reports/eeff";
  return generateReport(url, period, file);
}

// CAE
function fetchCAEReports() {
  return axios.get(COMPLIANCE_ENDPOINT + "/reports/cae");
}
function generateCAE(datas) {
  const config = {
    headers: { "Content-Type": "multipart/form-data" }
  };
  let formdata = new FormData();
  for (let data of Object.entries(datas)) {
    formdata.append(data[0], data[1]);
  }
  return axios.post(COMPLIANCE_ENDPOINT + "/reports/cae", formdata, config);
}

// IRE
function fetchIREReports() {
  return axios.get(COMPLIANCE_ENDPOINT + "/reports/ire");
}
function generateIRE(period, file) {
  const url = COMPLIANCE_ENDPOINT + "/reports/ire";
  return generateReport(url, period, file);
}

// ICI
function fetchICIReports() {
  return axios.get(COMPLIANCE_ENDPOINT + "/reports/ici");
}
function generateICI(datas) {
  const config = {
    headers: { "Content-Type": "multipart/form-data" }
  };
  let formdata = new FormData();
  for (let data of Object.entries(datas)) {
    formdata.append(data[0], data[1]);
  }
  return axios.post(COMPLIANCE_ENDPOINT + "/reports/ici", formdata, config);
}

// Otros
function generateOthers(file) {
  const config = {
    headers: { "Content-Type": "multipart/form-data" }
  };
  let formdata = new FormData();
  formdata.append("file", file);
  return axios.post(COMPLIANCE_ENDPOINT + "/reports/xml", formdata, config);
}

const procedures = [
  {
    name: "reco-registries",
    baseUrl: COMPLIANCE_ENDPOINT + "/recos/registries/",
    fetch: fetchRecoRegistries,
    generate: generateRecoRegistry,
    period: {
      symbol: null,
      regex: /^([0-9]{4})$/,
      each: 12
    }
  },
  {
    name: "order-registries",
    baseUrl: COMPLIANCE_ENDPOINT + "/orders/registries/",
    fetch: fetchOrdersRegistries,
    generate: generateOrdersRegistry,
    period: {
      symbol: null,
      regex: /^([0-9]{4})$/,
      each: 12
    }
  },
  {
    name: "trade-registries",
    baseUrl: COMPLIANCE_ENDPOINT + "/trades/registries/",
    fetch: fetchTradeRegistries,
    generate: generateTradeRegistry,
    period: {
      symbol: null,
      regex: /^([0-9]{4})$/,
      each: 12
    }
  },
  {
    name: "position-registries",
    baseUrl: COMPLIANCE_ENDPOINT + "/positions/registries/",
    fetch: fetchPositionRegistries,
    generate: generatePositionRegistry,
    period: {
      symbol: null,
      regex: /^([0-9]{4})$/,
      each: 12
    }
  },
  {
    name: "solvencyconsolidated",
    baseUrl: COMPLIANCE_ENDPOINT + "/reports/solvencyconsolidated/",
    fetch: fetchSolvencyConsolidatedReports,
    generate: generateSolvencyConsolidated,
    period: {
      symbol: "T",
      regex: /^([0-9]{4})T([0-9]{1})$/,
      each: 3
    }
  },
  {
    name: "solvency",
    baseUrl: COMPLIANCE_ENDPOINT + "/reports/solvency/",
    fetch: fetchSolvencyReports,
    generate: generateSolvency,
    symbol: "T",
    regex: /^([0-9]{4})T([0-9]{1})$/,
    each: 3
  },
  {
    name: "solvencyav",
    baseUrl: COMPLIANCE_ENDPOINT + "/reports/solvency/",
    fetch: fetchSolvencyReports,
    generate: generateSolvency,
    period: {
      regex: /^([0-9]{4})$/,
      each: 12
    }
  },
  {
    name: "eeff",
    baseUrl: COMPLIANCE_ENDPOINT + "/reports/eeff/",
    fetch: fetchEEFFReports,
    generate: generateEEFF,
    period: {
      symbol: "M",
      regex: /^([0-9]{4})M([0-9]{2})$/,
      each: 1
    }
  },
  {
    name: "seafi",
    baseUrl: COMPLIANCE_ENDPOINT + "/reports/eeff/",
    fetch: fetchEEFFReports,
    generate: generateEEFF,
    period: {
      symbol: null,
      regex: /^([0-9]{4})/,
      each: 12
    }
  },
  {
    name: "cae",
    baseUrl: COMPLIANCE_ENDPOINT + "/reports/cae/",
    fetch: fetchCAEReports,
    generate: generateCAE
  },
  {
    name: "ire",
    baseUrl: COMPLIANCE_ENDPOINT + "/reports/ire/",
    fetch: fetchIREReports,
    generate: generateIRE,
    period: {
      symbol: null,
      regex: /^([0-9]{4})$/,
      each: 12
    }
  },
  {
    name: "ici",
    baseUrl: COMPLIANCE_ENDPOINT + "/reports/ici/",
    fetch: fetchICIReports,
    generate: generateICI
  }
];

const getProcedureTypes = () => procedures.map(x => x.name);
const getProcedure = procedure => procedures.find(x => x.name === procedure);

export default {
  getClients,
  getServices,
  getSegments,
  generateCAE,
  generateICI,
  getProcedureTypes,
  getProcedure,
  getCorporateData,
  generateOthers
};
